export enum EPaymentModel {
  'Rucni unos placanja' = 'Rucni unos placanja',
}

export const errorStatus = ['11', '19', '20', '22', '23', '26', '27'];
export const unconfirmedStatus = ['10', '30', '40', '41', '42', '45', '50'];
export const paidStatus = ['51', '52', '46', '57'];
export const occupationStatus = ['70'];
export const fictitiousStatus = ['60'];

export const calculationOnCode = {
  10: 'Purchase price',
  20: 'Selling price',
  else: 'Purchase and selling price',
};

export const calculationOnNumber = {
  10: 10,
  20: 20,
};
